/*
  assets/hrc-diagnostic-config.js
  Constantes del Diagnostico HRC V1 (Prompt Maestro, secciones 10 y 18).
  Ninguna regla de negocio vive fuera de este archivo o del motor de
  puntuacion (hrc-diagnostic-scoring.js): nada de umbrales magicos sueltos
  en el resto del codigo.
*/
(function () {
  'use strict';

  var CONFIG = {
    versions: {
      playerScoring: 'PLAYER_V1.1',
      coachScoring: 'COACH_V1.1',
      scoring: 'HRC_SCORING_V1.0'
    },

    layerOrder: ['knowledge', 'application', 'consistency', 'demand', 'review'],

    levels: [
      { min: 1.00, max: 1.79, key: 'starting_point', label: 'Punto de partida' },
      { min: 1.80, max: 2.59, key: 'developing', label: 'En desarrollo' },
      { min: 2.60, max: 3.39, key: 'functional', label: 'Nivel funcional' },
      { min: 3.40, max: 4.19, key: 'advanced', label: 'Nivel avanzado' },
      { min: 4.20, max: 5.00, key: 'consolidated', label: 'Nivel consolidado' }
    ],

    bottleneck: { scoreCeiling: 3.40, minGapVsNextLayer: 0.25 },

    areaBalance: { equilibrada: [0, 1], irregular: [2, 2], muyDesequilibrada: [3, 4] },
    globalBalance: { equilibrado: [0, 0.59], diferenciasModeradas: [0.60, 1.19], muyDesigual: [1.20, Infinity] },

    priorityWeights: { need: 0.70, criticality: 0.15, goalMatch: 0.10, context: 0.05 },

    criticality: { none: 0, oneAnswer2: 30, twoOrMoreAnswer2: 50, oneAnswer1: 75, oneAnswer1AndAnotherLte2: 100 },
    goalMatch: { direct: 100, partial: 50, none: 0 },

    secondPriority: { scoreCeiling: 3.40 },
    connectedPriorities: { maxGap: 5 },

    perceptionMatch: {
      FULL_MATCH: 'full_match',
      PARTIAL_MATCH: 'partial_match',
      RELEVANT_DIFFERENCE: 'relevant_difference',
      UNCLEAR: 'unclear',
      EXTERNAL_LIMITATION: 'external_limitation'
    },

    qualityFlags: { ADEQUATE: 'adequate', LOW_DIFFERENTIATION: 'low_differentiation', TOO_FAST: 'too_fast' },
    qualityCriteria: { minDistinctValues: 3, maxSameAnswerRatio: 0.70, minReasonableSeconds: 60 },

    recommendation: {
      weights: {
        primaryArea: 30,
        secondPriority: 10,
        transversalLayer: 15,
        routeStep: 15,
        positionOrRole: 10,
        goal: 8,
        season: 7,
        editorialPriority: 5
      },
      thresholds: { excellent: 75, solid: 60, possibleComplement: 45 },
      maxOutput: { free: 1, main: 1, complementOrPack: 1, upcoming: 1 }
    },

    analyticsEvents: [
      'hrc_diagnostic_started',
      'hrc_diagnostic_audience_selected',
      'hrc_diagnostic_context_completed',
      'hrc_diagnostic_progress_25',
      'hrc_diagnostic_progress_50',
      'hrc_diagnostic_progress_75',
      'hrc_diagnostic_questions_completed',
      'hrc_diagnostic_teaser_viewed',
      'hrc_diagnostic_lead_submitted',
      'hrc_diagnostic_report_viewed',
      'hrc_diagnostic_product_viewed',
      'hrc_diagnostic_product_clicked',
      'hrc_diagnostic_waitlist_clicked',
      'hrc_diagnostic_restarted',
      'hrc_diagnostic_error'
    ],

    storageKey: 'hrc_diagnostic_v1_state',
    source: 'diagnostico_hrc_v1'
  };

  window.HRC_DIAGNOSTIC_CONFIG = CONFIG;
})();
